import Vue from 'vue'

// The card opts into this editor. Request workflows keep their existing path.
export default class ProductStatementAnswersState {
    rows = Vue.observable([])
    baseline = new Map()

    hydrate(rows) {
        this.baseline = new Map(rows.map(row => [row.statementId, {
            answer: row.ownAnswer,
            comment: row.comment,
        }]))
        this.rows.splice(0, this.rows.length, ...rows.map(row => ({
            ...row,
            sources: (row.sources || []).map(source => ({ ...source })),
        })))
    }

    change({ statementId, field, value }) {
        const row = this.rows.find(item => item.statementId === statementId)
        if (!row) return

        if (field === 'answer' && row.canEditAnswer === true && [true, false, null].includes(value)) {
            row.ownAnswer = value
            row.answer = value
        }
        if (field === 'comment' && row.canEditComment === true
            && (value === null || (typeof value === 'string' && value.length <= 32000))) {
            row.comment = value
        }
    }

    patch() {
        return this.rows.reduce((changes, row) => {
            const baseline = this.baseline.get(row.statementId)
            const change = { statementId: row.statementId }
            if (row.canEditAnswer === true && row.ownAnswer !== baseline.answer) {
                change.answer = row.ownAnswer
            }
            if (row.canEditComment === true && row.comment !== baseline.comment) {
                change.comment = row.comment
            }
            if (Object.keys(change).length > 1) changes.push(change)
            return changes
        }, [])
    }

    getState() {
        return this.rows.map(row => ({
            statementId: row.statementId,
            answer: row.ownAnswer,
            comment: row.comment,
        })).sort((a, b) => a.statementId - b.statementId)
    }
}
